import { MantineColor } from '@mantine/core';
import { z } from 'zod';

export const leadStatus = z.enum(['unique', 'no_unique', 'was_unique']);

export const leadStatusTextMap: Record<LeadStatus, { tag: string; singleLine: string }> = {
  unique: {
    tag: 'Уникален',
    singleLine: 'Уникален',
  },
  no_unique: {
    tag: 'Неуникален',
    singleLine: 'Неуникален',
  },
  was_unique: {
    tag: 'Уникальность\nзавершена',
    singleLine: 'Уникальность завершена',
  },
};

export const leadStatusColorMap: Record<LeadStatus, MantineColor> = {
  unique: 'green',
  no_unique: 'red',
  was_unique: 'yellow',
};

export type LeadStatus = z.output<typeof leadStatus>;
